module.exports = __webpack_public_path__ + "img/img1.2d62d66d.png";